export default __webpack_public_path__ + "static/media/gutargu1.8e328944.png";